<template>
  <div>
    <span v-for="(part, index) in parts" :key="index">
      <template v-if="isSlot(part)">
        <slot :name="getSlotName(part)"></slot> <!-- Render the slot if it's a placeholder -->
      </template>
      <template v-else>
        {{ part }}
      </template>
    </span>
  </div>
</template>

<script setup lang="ts">
// 翻译句子时，使用 #terms# 和 #privacy# 作为占位符增加插槽以适应更多情况
// "Agreed to #terms# & #privacy#"
import { computed, defineProps } from 'vue';

const props = withDefaults(defineProps<{
  text: string
}>(), {
  text: ''
});
const parts = computed(() => {
  if (props.text) {
    return props.text.split(/(#\w+#)/).filter(Boolean);
  }
  return [];
});
const isSlot = (part: string) => {
  return part.startsWith('#') && part.endsWith('#');
};
const getSlotName = (part: string) => {
  return part.slice(1, -1); // Remove the curly braces
};
</script>

<style scoped>
/* Add any necessary styles here */
</style>